import styled from "styled-components";

export const ShimmerWrapper = styled.div`
  animation: loading 2.5s infinite;
  position: absolute;
  z-index: 999;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;

  @keyframes loading {
    0% {
      transform: translateX(-150%);
    }
    50% {
      transform: translateX(-60%);
    }
    100% {
      transform: translateX(150%);
    }
  }
`;

export const ShimmerContent = styled.div`
  width: 50%;
  height: 100%;
  background: var(--background-shimmer);
  box-shadow: 0 0 30px 30px var(--background-shimmer);
  transform: skewX(-20deg);
`;
